import { render, staticRenderFns } from "./CarStatusCard.vue?vue&type=template&id=888c3d54&scoped=true&"
import script from "./CarStatusCard.vue?vue&type=script&lang=js&"
export * from "./CarStatusCard.vue?vue&type=script&lang=js&"
import style0 from "./CarStatusCard.vue?vue&type=style&index=0&id=888c3d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888c3d54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
